import helper from './helper'

export default (filters) => {
  filters = JSON.parse(JSON.stringify(filters))
  if (filters.dateStart && filters.dateEnd) {
    filters.dateStart = helper.dateToYMD(filters.dateStart)
    filters.dateEnd = helper.dateToYMD(filters.dateEnd)
  }
  if (parseInt(filters.priceRange) > 0) {
    filters.priceRange = parseInt(filters.priceRange)
    switch (filters.priceRange) {
      case 1:
        filters.price_to = 500
        break;
      case 2:
        filters.price_from = 500
        filters.price_to = 1000
        break;
      case 3:
        filters.price_from = 1000
        break;
    }
  }
  return filters
}
